import { render } from "./LabelTable.vue?vue&type=template&id=59bb5e91"
import script from "./LabelTable.vue?vue&type=script&lang=js"
export * from "./LabelTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__